export const onBoardingDateKey = 'onboarding_date';

export default function sendOnboardUTCDateToInsider(onBoardingUTCDateValue) {
  window?.driverAppBridge?.sendUTCDatePropertyToInsider?.(
    onBoardingDateKey,
    onBoardingUTCDateValue
  );
}
